import EditProduct from 'page/Application/ManageProductAndService/Product/EditProduct';
import ProductList from 'page/Application/ManageProductAndService/Product/ProductList';
import RegisterProduct from 'page/Application/ManageProductAndService/Product/RegisterProduct';
import { Outlet } from 'react-router-dom';
import { ProductProvider } from './component/ProductContext';

const Product = () => {
  return (
    <>
      <ProductProvider>
        <Outlet />
      </ProductProvider>
    </>
  );
};

export default Product;

export { EditProduct, ProductList, RegisterProduct };

